export const NIVEAUX_ARBITRES = [
    "international",
    "fédéral",
    "national",
    "un",
    "stagiaire ancien",
    "stagiaire nouveau",
]



// WEBPACK FOOTER //
// ./src/data/niveaux_arbitres.js